/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CrudService } from '../../services/crud.service';
import { ISettingsTable } from '../components/ami-select/ami-select.interface';

@Component({
  template: ''
})
export class SelectTemplate {
  @Output() selectedRowsEvent = new EventEmitter<any>();
  table: { settings: ISettingsTable; data: any[] } = {
    settings: {
      title: '',
      columns: []
    },
    data: null
  };
  suscriptionBase$: Subscription;

  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {}

  onReciveSelectedRows(rows: any) {
    this.selectedRowsEvent.emit(rows);
  }

  unsubscribeBase() {
    this.suscriptionBase$.unsubscribe();
  }
}
